import { Component, ViewChild } from '@angular/core';
import { Paginator } from '@app/classes';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { SettingsIntegrationBase } from '@app/models/company/settings/integrations/integration-base.model';
import { SettingsIntegration } from '@app/models/company/settings/settings-integration.model';
import { SettingsMenuService } from '@app/modules/settings/services/settings-menu.service';
import { NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { IndexView } from '@common/views';
import { IntegrationType } from '@models/common/integration-type.model';
import { DataField } from '@models/settings/data-field.model';

@Component({
    templateUrl: './integration-index.template.html',
    styleUrls: ['./integration-index.style.scss'],
})
export class IntegrationIndexView extends IndexView {
    @ViewChild('confirmDeleteDialog', { static: true }) confirmDeleteDialog: DeprecatedConfirmationDialogComponent;

    isLoading = true;

    fields: DataField[] = [];

    fieldPaginator: Paginator;
    fieldGroupPaginator: Paginator;

    integrationTypePaginator: Paginator;
    integrationPaginator: Paginator;

    constructor(
        public auth: AuthService,
        private notify: NotifyService,
        public settingsMenuService: SettingsMenuService
    ) {
        super();

        this.integrationTypePaginator = new Paginator(IntegrationType.query(), { shouldAutoLoadData: true });

        this.integrationPaginator = new Paginator(
            SettingsIntegration.param('company', this.auth.company.id).with('integrationType'),
            { shouldAutoLoadData: true }
        );
        this.integrationPaginator.onLoading((isLoading) => (this.isLoading = isLoading));
    }

    integrationTypeInUse(integrationType: IntegrationType): boolean {
        const items = <SettingsIntegration[]>this.integrationPaginator.values;

        if (!items) {
            return false;
        }

        return Boolean(items.find((integration) => integration.integrationType.id === integrationType.id));
    }

    onCreate(integrationDetail: SettingsIntegrationBase): void {
        integrationDetail
            .param('company', this.auth.company.id)
            .save()
            .then(() => {
                this.notify.success('Integration updated');
                this.integrationPaginator.loadData();
            })
            .catch((err) => {
                this.notify.error(err.message || 'Could not save');
            });
    }

    onToggle(integration: SettingsIntegration): void {
        integration
            .param('company', this.auth.company.id)
            .save()
            .then(() => {})
            .catch((err) => {
                this.notify.error(err.message || 'Integration not updated');
                this.isLoading = false;
            });
    }

    onDelete(integration: SettingsIntegration): void {
        this.confirmDeleteDialog.show().then((confirm) => {
            if (confirm) {
                this.isLoading = true;
                integration
                    .param('company', this.auth.company.id)
                    .delete()
                    .then(() => {
                        this.notify.success('Integration removed');
                        this.integrationPaginator.loadData();
                    })
                    .catch((err) => {
                        this.notify.error(err.message || 'Integration not removed');
                        this.isLoading = false;
                    });
            }
        });
    }

    onCancel(integrationDetail: SettingsIntegrationBase): void {
        integrationDetail.revert();
    }
}
